import { render, staticRenderFns } from "./ArtStatement.vue?vue&type=template&id=38d276ec&"
import script from "./ArtStatement.vue?vue&type=script&lang=js&"
export * from "./ArtStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports